export const START_LOADING = 'START_LOADING'
export const UPDATE_ATTRIBUTE_SELECTION = 'UPDATE_ATTRIBUTE_SELECTION'
